import * as React from 'react'
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox'
import { inputBackgroundDisabled, inputBorderDisabled } from 'app/theme/themeBase'

const UncheckedIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect x='5' y='5' width='14' height='14' rx='0.1' fill='#ffff' />
    <rect x='4' y='4' width='16' height='16' rx='1.1' stroke='currentColor' strokeWidth='2' />
  </svg>
)

const UncheckedDisabledIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect x='5' y='5' width='14' height='14' rx='0.1' fill={inputBackgroundDisabled} />
    <rect x='4' y='4' width='16' height='16' rx='1.1' stroke={inputBorderDisabled} strokeWidth='2' />
  </svg>
)

const CheckedIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect
      x='4'
      y='4'
      width='16'
      height='16'
      rx='1.1'
      fill='currentColor'
      stroke='currentColor'
      strokeWidth='2'
    />
    <path
      d='M10 16.4L6 12.4L7.4 11L10 13.6L16.6 7L18 8.4L10 16.4Z'
      fill='white'
    />
  </svg>
)

const CheckedDisabledIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <rect
      x='3'
      y='3'
      width='18'
      height='18'
      rx='2'
      fill={inputBorderDisabled}
    />
    <path
      d='M10 16.7L6 12.7L7.4 11.3L10 13.9L16.6 7.3L18 8.7L10 16.7Z'
      fill='white'
    />
  </svg>
)

interface IconSet {
  unchecked: React.ReactNode
  checked: React.ReactNode
  uncheckedDisabled?: React.ReactNode
  checkedDisabled?: React.ReactNode
}

const defaultIcons: IconSet = {
  unchecked: <UncheckedIcon />,
  checked: <CheckedIcon />,
  uncheckedDisabled: <UncheckedDisabledIcon />,
  checkedDisabled: <CheckedDisabledIcon />
}

type Props = CheckboxProps & {
  icons?: Partial<IconSet>
}

const CustomCheckbox: React.FC<Props> = ({
  icons,
  icon,
  checkedIcon,
  disabled,
  indeterminate,
  ...rest
}) => {
  const cfg = { ...defaultIcons, ...icons }

  const customIcon = disabled === true
    ? cfg.uncheckedDisabled ?? cfg.unchecked
    : cfg.unchecked

  const customCheckedIcon = disabled === true
    ? cfg.checkedDisabled ?? cfg.checked
    : cfg.checked

  return (
    <Checkbox
      disableRipple
      icon={icon ?? customIcon}
      checkedIcon={checkedIcon ?? customCheckedIcon}
      disabled={disabled}
      {...rest}
    />
  )
}

export default CustomCheckbox
